import { EXEC_PAGES, EXEC_RECOMMENDATIONS } from "../../data/reportContent";
import { Block } from "./ReportBody";

const ExecPage = ({ page }) => (
  <section id={page.id} className="report-section exec-page" data-testid={`section-${page.id}`}>
    <div className="report-section-head">
      <span className="report-kicker">Page {page.pageNumber}</span>
      <h2>{page.label}</h2>
    </div>
    {page.blocks.map((b, i) => (
      <Block block={b} sectionId={page.id} i={i} key={i} />
    ))}
  </section>
);

const ExecRecommendations = () => (
  <section id="exec-recommendations" className="report-section exec-page report-recommendations" data-testid="section-exec-recommendations">
    <div className="report-section-head">
      <span className="report-kicker">Page 7</span>
      <h2>Recommendations</h2>
    </div>
    <p className="visual-note">
      The same twelve recommendations as the full report, in the same order and meaning, shortened for a quick read.
    </p>
    <ol>
      {EXEC_RECOMMENDATIONS.map((r, i) => (
        <li key={i} data-testid={`exec-recommendation-${i + 1}`}>
          {r}
        </li>
      ))}
    </ol>
  </section>
);

// The Executive Summary is a faithful, shorter presentation of the locked full
// report: same numbers, sequencing, product roles, programme boundaries and
// CommunityHubCierge treatment. No new recommendation is introduced.
export const ExecSummaryBody = () => (
  <div className="report-container">
    {EXEC_PAGES.map((p) => (
      <ExecPage page={p} key={p.id} />
    ))}
    <ExecRecommendations />
  </div>
);
